import { render, staticRenderFns } from "./EditItemTypeAdditionalItemModal.vue?vue&type=template&id=00cc7cea"
import script from "./EditItemTypeAdditionalItemModal.vue?vue&type=script&lang=js"
export * from "./EditItemTypeAdditionalItemModal.vue?vue&type=script&lang=js"
import style0 from "./EditItemTypeAdditionalItemModal.vue?vue&type=style&index=0&id=00cc7cea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports